import React from 'react';
import { LoadingProgress } from '@vimily/bonjoro-ui-components-v2/LoadingProgress';
import { PlanUsage, PlanUsageType } from '~/types/models';

const progressColorClassName = {
  [PlanUsageType.VideoUsage]: 'v2-bg-blue-500',
  [PlanUsageType.Templates]: 'v2-bg-yellow-500',
  [PlanUsageType.Workflows]: 'v2-bg-blue-500',
  [PlanUsageType.Users]: 'v2-bg-green-500',
  [PlanUsageType.VideoTestimonials]: 'v2-bg-magenta-500',
  [PlanUsageType.Publishables]: 'v2-bg-yellow-500',
};

export interface UsagesListProps {
  usages?: PlanUsage[];
}

export function UsagesList({ usages }: UsagesListProps) {
  return (
    <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-4'>
      {usages?.map((usage) => {
        if (usage?.limit == null) return;

        return (
          <div
            key={usage.title}
            className='flex flex-row flex-wrap v2-bg-neutral-50 py-2 px-4 items-center gap-x-4 w-full rounded-md'
          >
            <span className='w-2/5 flex flex-row flex v2-text-neutral-900 items-center justify-between'>
              <span className='flex flex-row gap-x-1.5 items-center flex-wrap'>
                <span className='text-base'>{usage?.title}</span>
                {usage?.subtitle && (
                  <span className='v2-text-neutral-500 text-xs leading-3'>
                    {usage?.subtitle}
                  </span>
                )}
              </span>
              <span className='text-base'>
                {`${usage?.count}/${usage?.limit}`}
              </span>
            </span>
            <LoadingProgress
              progress={usage?.count}
              maxProgress={usage?.limit}
              className='h-[20px] flex-1 !cursor-default'
              progressClassName={`${progressColorClassName[usage?.title]}`}
            />
          </div>
        );
      })}
    </div>
  );
}
